/**
 * @flow
 * @relayHash e3a73a5b00eb5c96453ce3ef06723199
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PrePostMutationInput = {|
  formName: string,
  responses: $ReadOnlyArray<?Response>,
  clientMutationId?: ?string,
|};
export type Response = {|
  question: string,
  answer: string,
|};
export type DemographicsMutationVariables = {|
  input: PrePostMutationInput
|};
export type DemographicsMutationResponse = {|
  +prepostMutation: ?{|
    +nextForm: ?string
  |}
|};
export type DemographicsMutation = {|
  variables: DemographicsMutationVariables,
  response: DemographicsMutationResponse,
|};
*/


/*
mutation DemographicsMutation(
  $input: PrePostMutationInput!
) {
  prepostMutation(input: $input) {
    nextForm
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "PrePostMutationInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "prepostMutation",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PrePostMutationPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "nextForm",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DemographicsMutation",
    "type": "RelayMutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DemographicsMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DemographicsMutation",
    "id": null,
    "text": "mutation DemographicsMutation(\n  $input: PrePostMutationInput!\n) {\n  prepostMutation(input: $input) {\n    nextForm\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '19748486c4ce2be532da1a0a1aacd6b9';
module.exports = node;
